import { useState } from 'react'

const getType = type => {
  if (!type) return type
  return type.toLowerCase() === 'text' ? 'string' : type
}

export const useDataTable = () => {
  const [sortingObj, setSortingObj] = useState({})
  const [searchArr, createSearchArray] = useState([])
  const [pageIndex, setPageIndex] = useState(0)

  const setSearchArry = (() => {
    let debounceTimer

    return searchObj => {
      // Convert type if it's a text field
      if (searchObj.type) {
        searchObj.type = getType(searchObj.type)
      }

      if (searchObj.type === 'date') {
        if (!searchObj.value) {
          searchObj.value = ''
        } else {
          const date = new Date(searchObj.value)
          if (isNaN(date.getTime())) {
            searchObj.value = '' // Invalid date
          } else {
            searchObj.value = new Intl.DateTimeFormat('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              timeZone: 'UTC', // Specify UTC timezone
            }).format(date)
          }
        }
      }

      if (searchObj.type === 'dateRange') {
        const { from, to } = searchObj.value

        const formatDate = dateString => {
          if (!dateString) return ''
          const date = new Date(dateString)
          if (isNaN(date.getTime())) return '' // Invalid date

          return new Intl.DateTimeFormat('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            timeZone: 'UTC', // Specify UTC timezone
          }).format(date)
        }

        const formattedFromDate = formatDate(from)
        const formattedToDate = formatDate(to)

        // Set value to empty if both dates are empty or invalid
        if (!formattedFromDate && !formattedToDate) {
          searchObj.value = ''
        } else {
          searchObj.value = `${formattedFromDate},${formattedToDate}`
        }
      }

      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => {
        const isEmptyValue = (value) => {
          if (!value || value === '') return true
          if (searchObj.type === 'dateRange' && (value === ',' || value === ',,' || value.split(',').every(d => !d))) return true
          return false
        }

        // Remove items with empty values and handle new search
        if (isEmptyValue(searchObj.value)) {
          // Remove the item with the matching field
          const filteredArray = searchArr.filter(filter => filter.field !== searchObj.field)
          createSearchArray(filteredArray)
        } else {
          // Update existing or add new item
          const index = searchArr.findIndex(filter => filter.field === searchObj.field)
          if (index !== -1) {
            // Update existing item
            const updatedArray = [...searchArr]
            updatedArray[index] = searchObj
            createSearchArray(updatedArray)
          } else {
            // Add new item
            createSearchArray([...searchArr, searchObj])
          }
        }
      }, 1000)
    }
  })()

  const resetSearchArr = () => {
    createSearchArray([])
  }


  const handleResetAll = () => {
    createSearchArray([])
    setSortingObj({})
    setPageIndex(0)
  }

  return {
    searchArr,
    sortingObj,
    pageIndex,
    setSortingObj,
    setSearchArry,
    setPageIndex,
    resetSearchArr,
    handleResetAll
  }
}

